import { Injectable } from "@angular/core";
import { AddCompanyContactUsecase } from "@arch/domain/application/usecase/add-company-contact.usecase";

@Injectable({
    providedIn: "root"
})
export class AddCompanyContactController {
    constructor(
        private readonly addCompanyContactUsecase: AddCompanyContactUsecase // Replace with actual use case
    ) {}

    public async execute(input: Input): Promise<boolean> {
        const response = await this.addCompanyContactUsecase.execute(input);
        return response;
    }
}

type Input = {
    accountingId: string;
    type: string;
    contact: {
        email?: string;
        name: string;
        whatsapp?: string;
        relations: {
            nps: {
                status: number;
            };
            user: {
                status: number;
            };
        };
        type: string;
        accountingId: string;
        companyId: string;
    };
};
